var _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect4, _rect5, _path9, _path10, _path11;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFitnessTrackers = function SvgFitnessTrackers(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.45 406.78l59.63 59.62a10.32 10.32 0 0 0 14.86-.26c4.52-4.88 9.54-9.38 16.39-12.7a115.47 115.47 0 0 1 18.79-7.37 12 12 0 0 0 5.41-3.12l244.21-244.21a11.92 11.92 0 0 0 2.74-4.24c2.16-5.69 5.4-14.07 9.38-22 2.64-5.27 9-11 13.61-15.37a10.32 10.32 0 0 0 .1-14.91L339.79 85a10.31 10.31 0 0 0-14.68.29 66.73 66.73 0 0 1-15.52 11.5 146 146 0 0 1-22.73 8.76 12 12 0 0 0-4.93 3L40.52 349.9a11.9 11.9 0 0 0-2 2.63c-2.44 4.37-6.42 14-11.63 22.6-4.56 7.54-9.95 12.07-14.48 18.24a10.34 10.34 0 0 0 1.04 13.41z",
    fill: "#fdb73e"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.68,
    y: 219.11,
    width: 353.83,
    height: 110.25,
    rx: 8,
    transform: "rotate(-45 206.601 274.233)",
    fill: "#6ab4e5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.86,
    y: 227.02,
    width: 328.74,
    height: 93.69,
    rx: 8,
    transform: "rotate(-45 206.23 273.867)",
    fill: "#fdb73e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.83,
    y: 236.82,
    width: 312.79,
    height: 74.09,
    rx: 5,
    transform: "rotate(-45 206.23 273.867)",
    fill: "#6e5f91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#16a99e",
    d: "M111.853 374.747l15.033-15.034 19.014 19.015-15.033 15.033z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#93b847",
    d: "M200.052 305.55l15.033-15.033 9.504 9.503-15.033 15.033zM118.07 341.61l15.034-15.033 32.463 32.463-15.033 15.033z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0592b",
    d: "M167.794 312.638l15.033-15.033 22.09 22.09-15.033 15.033zM127.454 311.645l15.033-15.033 42.752 42.751-15.033 15.034z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#16a99e",
    d: "M399.36 192.85h190.81v231.24H399.36z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#015e85",
    d: "M399.36 427.32h190.81V196.08L399.36 427.32z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdb73e",
    d: "M398.15 193.39l23.72-30.72h143.38l23.71 30.72H398.15z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#015e85",
    d: "M590.17 424.09l-23.71 30.72H423.08l-23.72-30.72h190.81z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 434.26,
    y: 171.29,
    width: 119.13,
    height: 10.78,
    rx: 3.63,
    fill: "#015e85"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 434.26,
    y: 434.87,
    width: 119.13,
    height: 10.78,
    rx: 3.63,
    fill: "#fdb73e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ab4e5",
    d: "M448.41 114.15h93.79v63.06h-93.79zM448.41 440.8h93.79v63.06h-93.79z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#015e85",
    d: "M448.41 114.15l-17.11 48.78h17.25l-.14-48.78zM448.41 504.13l-17.11-48.78h17.25l-.14 48.78z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M508 271.72a4.06 4.06 0 1 0 .43 8.1h11.81l3 10.81h-40.03l-2-6.59a4.07 4.07 0 0 0-3.88-2.87h-15.26a4.06 4.06 0 0 0 .43 8.11h11.85l1.35 4.43-9.41 12.87a24.1 24.1 0 0 0-10.55-2.45 24.31 24.31 0 1 0 23.68 29.71h11.43a4.09 4.09 0 0 0 2.79-1.14l32.74-31 1.23 4.27a24.16 24.16 0 1 0 9.15-1.86c-.44 0-.87.06-1.31.08l-8.31-29.53a4.06 4.06 0 0 0-3.88-3H508zm-22.28 27h32.07l-24.93 23.59zm-7 4.72l6.75 22.28h-5.53a24.26 24.26 0 0 0-7-14.43zm-22.92 8.78a16.31 16.31 0 0 1 5.66 1.06l-10.3 14.09a4.06 4.06 0 0 0 3.29 6.46H471a16.2 16.2 0 1 1-15.28-21.61zm82 0a16.15 16.15 0 1 1-7.93 1.52l4.43 15.74a4.05 4.05 0 1 0 8-1.48 4.44 4.44 0 0 0-.21-.71zm-69.66 5.66a16 16 0 0 1 3.63 7.8h-9.33zM302 397.7a2.18 2.18 0 0 0 2.1-2.27 2.14 2.14 0 0 0-2.1-2.1c-1.94 0-19.43-.65-19.43-21.05a2.11 2.11 0 0 0-4.21 0c0 20.4-17.48 21.05-19.43 21.05h-.16a2.11 2.11 0 0 0-1.94 2.1 2.15 2.15 0 0 0 2.1 2.11c2.11 0 19.43.64 19.43 21a2.14 2.14 0 0 0 2.11 2.11 1.87 1.87 0 0 0 1.94-1.95c0-20.4 17.48-21 19.43-21z",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFitnessTrackers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fitness_trackers.164c067f.svg";
export { ForwardRef as ReactComponent };